import Model from 'models/Model';
import Client from '../../claims/client/Model.Client';
import Contract from '../contract/Model.Contract';
import contractClientHistoryListApi from './list/Api.ContractClientHistory.List';
import MediaFile from 'models/core/mediaFile/Model.MediaFile';

export default class ContractClientHistory
  extends Model<Model.IContractClientHistory>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractClientHistory>
{
  id: number;
  startDateUtc: string;
  endDateUtc: string;

  clientId: number;
  client: Client;
  contractId: number;
  contract: Contract;

  documentAggregate?: MediaFile | null;
  transferDocuments: MediaFile[];

  constructor(
    data: Partial<Model.IContractClientHistory> | Utils.FormData<Model.IContractClientHistory>,
    language?: Locale.Languages
  ) {
    super(
      {
        contract: Contract,
        client: Client,
        documentAggregate: MediaFile,
        transferDocuments: [MediaFile],
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: `${this?.contract?.appNumber}/${this?.client?.displayInfo?.title}` || this.id.toString(),
    };
  }
  static async list(body?: Api.Core.ContractClientHistory.List.IRequest) {
    const { payload, ...rest } = await contractClientHistoryListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ContractClientHistory(it)),
        count: payload.count,
      },
    };
  }
}
